import React from 'react';

// Small hand-built line-art icon set, one per subject key — replaces the flat emoji glyphs with
// something that can take a hover animation and matches the subject's accent color via
// `stroke="currentColor"` (color is set by the CSS `color` property on the wrapping element).
const ICONS = {
  'computer-science-information': (
    <>
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M8 20h8M12 16v4" />
    </>
  ),
  'engineering-applied-technology': (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </>
  ),
  'mathematics-natural-sciences': (
    <>
      <path d="M9 3h6M10 3v5l-5 9a2 2 0 0 0 1.8 3h10.4a2 2 0 0 0 1.8-3l-5-9V3" />
      <path d="M7.5 14h9" />
    </>
  ),
  'social-sciences-management': (
    <>
      <path d="M4 19V10M10 19V5M16 19v-7M20 19V8" />
      <path d="M3 19h18" />
    </>
  ),
  'literature-communication': (
    <>
      <path d="M3 5.5C5 4 8 4 12 5.5V18.5C8 17 5 17 3 18.5V5.5Z" />
      <path d="M21 5.5C19 4 16 4 12 5.5V18.5C16 17 19 17 21 18.5V5.5Z" />
    </>
  ),
  'history-geography-biography': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a13 13 0 0 1 0 18M12 3a13 13 0 0 0 0 18" />
    </>
  ),
  'philosophy-psychology': (
    <>
      <path d="M9 18h6M10 21h4" />
      <path d="M12 3a6 6 0 0 0-4 10.5c.6.5 1 1.3 1 2.1V16h6v-.4c0-.8.4-1.6 1-2.1A6 6 0 0 0 12 3Z" />
    </>
  ),
  'religion-culture': (
    <>
      <path d="M12 3v18M5 9c2 2 5 2 7 0M19 9c-2 2-5 2-7 0M3 21c2.5-3 6-3 9 0M21 21c-2.5-3-6-3-9 0" />
    </>
  ),
  'language-linguistics': (
    <>
      <path d="M21 11.5a8.5 6.5 0 1 1-3.3 5.1L4 19l1.8-3.6A8.5 6.5 0 0 1 21 11.5Z" />
    </>
  ),
  'arts-design-recreation': (
    <>
      <path d="M12 3a9 7 0 1 0 0 14c1 0 1.5-.6 1.5-1.3s-.5-1.1-.5-1.8c0-.9.8-1.4 1.7-1.4H17a4 3.5 0 0 0 4-3.5C21 5.6 17 3 12 3Z" />
      <circle cx="8" cy="11" r="1" />
      <circle cx="11" cy="8" r="1" />
      <circle cx="15" cy="8.5" r="1" />
    </>
  ),
};

function SubjectIcon({ subjectKey, size = 24, className }) {
  const paths = ICONS[subjectKey];

  if (!paths) {
    return null;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
}

export default SubjectIcon;
